import { render, staticRenderFns } from "./CustomQuestionAnswerCheckbox.vue?vue&type=template&id=69145cdc"
import script from "./CustomQuestionAnswerCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports